import React from 'react';

const LOADER_GIF = 'https://s01.live2support.com/dashboardv2/chatassets/img/loader_new.gif';

const LoadingIndicator = ({ size = 30, alt = 'Loading...', style = {}, ...props }) => (
  <img
    src={LOADER_GIF}
    width={size}
    height={size}
    alt={alt}
    role="status"
    style={{ width: size, height: size, objectFit: 'contain', verticalAlign: 'middle', ...style }}
    {...props}
  />
);

export default LoadingIndicator;